import React, { PureComponent, PropTypes } from 'react';

import Item from './Item';

export default class AnyItem extends PureComponent {
    static propTypes = {
        isSelected: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
    }

    render() {
        // TODO: set 'any' class
        return (
            <Item
                text="Any"
                isSelected={this.props.isSelected}
                onClick={this.props.onClick}
            ></Item>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/SelectList/AnyItem.jsx